import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    openTimeTitle;
    value;
    rulesLength;
    minValue;
    maxValue;
    disabled;
    ruleForm = {
        trashBinUncoverTime: this.$props.value,
    };
    get rules() {
        return {
            trashBinUncoverTime: [
                {
                    required: true,
                    message: `${this.$t('please')}${this.$t(this.openTimeTitle)},${this.rulesLength}`,
                    trigger: 'blur',
                },
                {
                    validator: (rule, value, callback) => {
                        const reg = /^(([1-9][0-9]{0,4})|100000)$/;
                        if (!reg.test(value)) {
                            callback(new Error(`${this.$t('please')}${this.$t(this.openTimeTitle)},${this.rulesLength}`));
                        }
                        else {
                            callback();
                        }
                    },
                    trigger: 'blur',
                },
            ],
        };
    }
    isValidate() {
        let isValidate = null;
        this.$refs.ruleForm.validate((valid) => {
            if (valid) {
                isValidate = true;
            }
            else {
                isValidate = false;
            }
        });
        return isValidate;
    }
    changeValue(val) {
        this.$emit('input', val);
    }
};
__decorate([
    Prop({ type: String })
], default_1.prototype, "openTimeTitle", void 0);
__decorate([
    Prop({ type: String })
], default_1.prototype, "value", void 0);
__decorate([
    Prop({ type: String, default: '1-100000' })
], default_1.prototype, "rulesLength", void 0);
__decorate([
    Prop({ type: Number, default: 0 })
], default_1.prototype, "minValue", void 0);
__decorate([
    Prop({ type: Number, default: 0 })
], default_1.prototype, "maxValue", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
default_1 = __decorate([
    Component({
        name: 'OpenTime',
        components: {},
        i18n: {
            messages: {
                zh: {
                    please: '请输入',
                },
                en: {
                    please: 'Please enter',
                },
            },
        },
    })
], default_1);
export default default_1;
